/*
 * @Description:投稿管理路由
 * @Author: jiang.weiwei
 * @LastEditors: Please set LastEditors
 * @Date: 2017-12-06 19:47:46
 * @LastEditTime: 2022-03-18 15:27:47
 */
'use strict';
angular.module('submissionRouterModule', []).config([
    '$stateProvider',
    function($stateProvider) {
        $stateProvider
            .state('index.submissionmanage', {
                url: '/submissionmanage',
                views: {
                    'main@index': {
                        template: "<div ui-view='main'></div>",
                        controller: 'submissionManageCtrl'
                    }
                }
            })
            .state('index.submissionmanage.personallibrary', {
                url: '/personallibrary',
                views: {
                    'main@index.submissionmanage': {
                        templateUrl:
                            './main/submissionManage/personalLibrary/personalLibrary_tpl.html',
                        controller: 'personalLibraryCtrl'
                    }
                }
            })
            .state('index.submissionmanage.pgcpersonallibrary', {
                url: '/pgcpersonallibrary',
                views: {
                    'main@index.submissionmanage': {
                        templateUrl:
                            './main/submissionManage/personalLibrary/pgcPersonalLibrary_tpl.html',
                        controller: 'pgcPersonalLibraryCtrl'
                    }
                }
            })
            .state('index.submissionmanage.submissionlibrary', {
                url: '/submissionlibrary',
                views: {
                    'main@index.submissionmanage': {
                        templateUrl:
                            './main/submissionManage/submissionLibrary/submissionLibrary_tpl.html',
                        controller: 'submissionLibraryCtrl'
                    }
                }
            })
            .state('index.submissionmanage.pgcsubmissionlibrary', {
                url: '/pgcsubmissionlibrary',
                views: {
                    'main@index.submissionmanage': {
                        templateUrl:
                            './main/submissionManage/submissionLibrary/pgcSubmissionLibrary_tpl.html',
                        controller: 'pgcSubmissionLibraryCtrl'
                    }
                }
            })
            .state('index.submissionmanage.rejectionmanage', {
                url: '/rejectionmanage',
                views: {
                    'main@index.submissionmanage': {
                        templateUrl: './main/submissionManage/rejectionManage/rejectionmanage_tpl.html',
                        controller: 'rejectionManageCtrl'
                    }
                }
            })
            .state('index.submissionmanage.explosionmanage', {
                url: '/explosionmanage',
                views: {
                    'main@index.submissionmanage': {
                        templateUrl:
                            './main/submissionManage/explosionManage/explosionManage_tpl.html',
                        controller: 'explosionManageCtrl'
                    }
                }
            })
            .state('index.submissionmanage.publishexplosion', {
                url: '/publishexplosion',
                views: {
                    'main@index.submissionmanage': {
                        templateUrl:
                            './main/submissionManage/publishExplosion/publishExplosion_tpl.html',
                        controller: 'publishExplosionCtrl'
                    }
                }
            });
    }
]);
